import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { Container } from './styles';

interface Props {
  preferredProvince?: string;
  selectProvinceToSave: () => void;
  preferredLocale?: string;
  idToAppend: string;
}
const ProvinceSelector = ({ preferredProvince = 'ON', selectProvinceToSave, preferredLocale = 'en', idToAppend }: Props) => {
  const PROVINCES = [
    'AB',
    'BC',
    'MB',
    'NB',
    'NL',
    'NS',
    'ON',
    'PE',
    'QC',
    'SK',
  ];

  return (
    <Container>
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <label htmlFor={`${idToAppend}ProvSelector`}>
        <p className="provinceSelect">
          {preferredLocale === 'en'
            ? ReactHtmlParser('Select your province')
            : ReactHtmlParser('Sélectionnez votre province')}
        </p>
        <select
          id={`${idToAppend}ProvSelector`}
          name={`${idToAppend}ProvSelector`}
          aria-label="province-desc"
          value={preferredProvince}
          onChange={selectProvinceToSave}
        >
          {PROVINCES.map((province) => (
            <option
              key={`${idToAppend}${province}`}
              id={`${idToAppend}${province}`}
              value={province}
            >
              {province}
            </option>
          ))}
        </select>
      </label>
    </Container>
  );
};

export default ProvinceSelector;
